export enum ShareLinkRowStatus {
  Active = "active",
  Inactive = "inactive",
  Expired = "expired",
  Burned = "burned",
}

const STATUS_STYLES: Record<ShareLinkRowStatus, { color: string; bg: string }> = {
  [ShareLinkRowStatus.Active]: { color: "#10B981", bg: "#ECFDF5" },
  [ShareLinkRowStatus.Inactive]: { color: "#6B7280", bg: "#F3F4F6" },
  [ShareLinkRowStatus.Expired]: { color: "#EF4444", bg: "#FEF2F2" },
  [ShareLinkRowStatus.Burned]: { color: "#6B7280", bg: "#F3F4F6" },
};

export function resolveShareLinkRowStatus(link: {
  isActive: boolean;
  expiresAt: string;
  downloadCount: number;
  maxDownloads: number;
}): ShareLinkRowStatus {
  if (!link.isActive) return ShareLinkRowStatus.Inactive;
  if (new Date(link.expiresAt) < new Date()) return ShareLinkRowStatus.Expired;
  if (link.downloadCount >= link.maxDownloads) return ShareLinkRowStatus.Burned;
  return ShareLinkRowStatus.Active;
}

export function chipStyleForShareLinkStatus(status: ShareLinkRowStatus): {
  color: string;
  bg: string;
} {
  return STATUS_STYLES[status];
}
